<template>
<el-dialog
  :visible.sync="dialogVisible"
  @closed="close"
  append-to-body
  width="1000px">
  <CourtList v-if="dialogVisible" />
</el-dialog>
</template>

<script>
import CourtList from "./CourtList";
export default {
  name: "CourtWin",
  components: {CourtList},
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/litigation/court/CourtWin.vue